import { render, staticRenderFns } from "./RecapSDDB2B.vue?vue&type=template&id=24ba687b&"
import script from "./RecapSDDB2B.vue?vue&type=script&lang=js&"
export * from "./RecapSDDB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports